import { Col, Row } from "antd";
import * as React from "react";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";

import { FormComponentProps } from "antd/lib/form";
import { PbrInputCpf } from "src/components/common/PbrInputCpf/PbrInputCpf";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { CnpjMask } from "src/util/Masks/CnpjMask";

interface IEditTradeOwnerPJ extends FormComponentProps {
  currentTrade: ITrade;
  onChange: (value: Partial<ITradeOwner>) => void;
}

export const EditTradeOwnerPJ: React.FC<IEditTradeOwnerPJ> = ({
  currentTrade,
  onChange,
  form
}) => {
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInput
            name="fullName"
            formWrapper={form}
            value={currentTrade.tradeOwner.fullName}
            style={{ color: "black" }}
            placeholder={"Razão Social"}
            formItemProps={{ label: "Razão Social" }}
            rules={[{ required: true, message: "O Razão Social é obrigatório" }]}
            onChange={e => onChange({ fullName: e.target.value })}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInputCpf
            name="cpfCnpj"
            value={CnpjMask(currentTrade.tradeOwner.cpfCnpj)}
            style={{ color: "black" }}
            placeholder={"CNPJ"}
            formItemProps={{ label: "CNPJ" }}
            rules={[{ required: true, message: "O CNPJ é obrigatório" }]}
            allowCnpj={true}
            onChange={e => onChange({ cpfCnpj: e.target.value })}
            formWrapper={form}
          />
        </Col>
      </Row>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditTradeOwner/EditTradeOwnerPJ.tsx